"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _root;

  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (_root = {
      borderTop: "1px solid ".concat(colors.inactive),
      transform: 'translateY(-1px)',
      padding: spacing(2.5, 0),
      margin: spacing(0, 2.5),
      flex: '1 0 100%'
    }, (0, _defineProperty2.default)(_root, breakpoint.up('md'), {
      flex: "0 0 calc(50% - ".concat(spacing(5), ")")
    }), (0, _defineProperty2.default)(_root, breakpoint.up('lg'), {
      flex: "0 0 calc(33% - ".concat(spacing(5), ")")
    }), (0, _defineProperty2.default)(_root, breakpoint.up('xl'), {
      flex: "0 0 calc(25% - ".concat(spacing(5), ")")
    }), _root)
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors, breakpoint }}", function () {
  return [_useTheme2.default];
});

var Section = function Section(props, ref) {
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    ref: ref,
    css: classes.root,
    flexDirection: "column"
  }, props));
};

__signature__(Section, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Section);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Section.tsx");
  reactHotLoader.register(Section, "Section", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Section.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/Section.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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